import { lazy, Suspense } from "react";
import CabifyBanner from "../cabifyClone/CabifyBanner";
import CabifyChoose from "../cabifyClone/CabifyChoose";

const ShuttleAppreciation = lazy(() => import("../../shuttle_software/ShuttleAppreciation"));
const TaxiFaq = lazy(() => import("../../taxiDispatchSoftware/TaxiFaq"));
const CabifyFeature = lazy(() => import("../cabifyClone/CabifyFeature"));
const CabifyFeatureTwo = lazy(() => import("../cabifyClone/CabifyFeatureTwo"));
const CabifyMinimum = lazy(() => import("../cabifyClone/CabifyMinimum"));
const CabifyPlace = lazy(() => import("../cabifyClone/CabifyPlace"));
const CabifySupport = lazy(() => import("../cabifyClone/CabifySupport"));

const bannerData = {
  title: "Blue Smart India Taxi Clone App",
  description: "Mobility Infotech brings you a ready-to-deploy Taxi Blue Smart India Clone App—a powerful ride-hailing platform designed specifically for India’s fast-growing mobility sector. Experience a seamless, branded launch with advanced features, modern design, and unmatched scalability to build your taxi business in the Indian market.",
  image: "/assets/home/cabify-banner.webp",
  btn: "get free demo",
  breadcrumbData: {
    newClass: "white-breadcrumb",
    list: [
      {
        page: "Home",
        slug: "/"
      },
      {
        page: "blue smart Clone App",
        slug: ""
      },
    ]
  }
};

const chooseData = {
  titlepart1: "Why Choose Our ",
  titlepart2: "Taxi Blue Smart India Clone",
  titlepart3: "Script?",
  description: "Mobility Infotech’s Taxi Blue Smart India Clone App is a complete taxi booking solution, crafted to help you launch quickly and efficiently. With real-time GPS tracking, integrated payment options, and intuitive interfaces for riders, drivers, and admins, this platform is built for growth, scale, and adaptability in India’s unique mobility landscape.",
  pointer1: "Rapid Market Launch",
  pointer2: "User-Centric Experience",
  pointer3: "Feature-Rich Framework",
  pointer4: "Timely Delivery Commitment",
  pointer5: "White-Labeled Solution",
  pointer6: "Full Brand Control",
  pointer7: "Integrated Payment Systems",
  pointer8: "Fully Customizable Platform",
  pointer9: "Cost-Efficient Build",
  image: "/assets/home/cabify-choose.webp",
  backImage: "/assets/home/cabify-choose-back.webp",
};

const featureData = {
  titlePart1: "Feature Suite for Riders,",
  titlePart2: "Drivers & Admins",

  feature1: {
    image: "/assets/home/cabify-feature-1.webp",
    title1: "Instant Fare Details",
    description1: "Get cost predictions based on distance, traffic, and time.",
    title2: "Emergency SOS Alerts",
    description2: "Safety-first with real-time emergency contact options.",
    title3: "Ratings & Reviews",
    description3: "Two-way feedback for service quality.",
    title4: "Smooth Profile Setup",
    description4: "Easy sign-up via mobile number, OTP, or email.",
    title5: "Live Location Tracking",
    description5: "Track drivers in real-time with updates.",
    title6: "Vehicle Selection",
    description6: "Choose economy, premium, or EV taxis.",
    title7: "Smart Trip History",
    description7: "View past rides, invoices, and receipts.",
    title8: "Multi-Stop Rides",
    description8: "Add extra stops in one trip.",
  },

  feature2: {
    image: "/assets/home/cabify-feature-2.webp",
    title1: "Trip Request Management",
    description1: "Accept/decline rides instantly.",
    title2: "Route Navigation & Optimization",
    description2: "GPS navigation for best routes.",
    title3: "Earnings & Trip Summary",
    description3: "Daily, weekly, and monthly reports.",
    title4: "Driver Profile & Document Upload",
    description4: "Upload licenses, insurance, and IDs.",
    title5: "Availability Toggle",
    description5: "Switch online/offline anytime.",
    title6: "Push Notifications",
    description6: "Alerts for rides, payments, and updates.",
    title7: "Built-in SOS Function",
    description7: "Emergency help in a single tap.",
    title8: "Rider Communication",
    description8: "Secure chat or call with riders.",
  },

  feature3: {
    image: "/assets/home/cabify-feature-3.webp",
    title1: "Comprehensive Dashboard",
    description1: "Monitor trips, revenue, drivers, and riders.",
    title2: "User & Driver Management",
    description2: "Approve, verify, and manage accounts.",
    title3: "Real-Time Trip Monitoring",
    description3: "Track active trips in real-time.",
    title4: "Fare Control",
    description4: "Configure fares, surges, and categories.",
    title5: "Commission & Payout Tools",
    description5: "Manage commissions and driver payments.",
    title6: "Advanced Reporting",
    description6: "Export revenue, usage, and behavior analytics.",
    title7: "Marketing Campaign Tools",
    description7: "Create promo codes and referral programs.",
    title8: "Ride Dispute Resolution",
    description8: "Manage complaints with ease.",
  },
}

const featureTwoData = {
  titlePart1: "Highlighting the",
  titlePart2: "top features",
  btn: "More features",
  rider: {
    image1: "/assets/home/lyft-feature-rider1.webp",
    title1: "Smarter Rides, Better Comfort",
    description1: "Eco-friendly EVs for safe, comfortable travel.",
    image2: "/assets/home/lyft-feature-rider2.webp",
    title2: "Get estimated trip cost",
    description2: "See your fare upfront before booking.",
    image3: "/assets/home/lyft-feature-rider3.webp",
    title3: "Contact the driver",
    description3: "Call or chat with drivers in-app.",
    image4: "/assets/home/lyft-feature-rider4.webp",
    title4: "Use multiple payment options",
    description4: "Pay via UPI, cards, wallets, or cash.",
  },
  driver: {
    image1: "/assets/home/lyft-feature-driver1.webp",
    title1: "Add payout account",
    description1: "Link payout accounts for secure transfers.",

    image2: "/assets/home/lyft-feature-driver2.webp",
    title2: "Cancel the trip",
    description2: "Cancel rides if needed.",

    image3: "/assets/home/lyft-feature-driver3.webp",
    title3: "View earnings",
    description3: "Clear breakdown of income.",

    image4: "/assets/home/lyft-feature-driver4.webp",
    title4: "View trip details",
    description4: "View completed rides easily.",

    image5: "/assets/home/lyft-feature-driver5.webp",
    title5: "Add toll charges",
    description5: "Auto-add tolls for accurate fares.",
  },

  admin: {
    image1: "/assets/home/zip-feature-1.webp",
    title1: "Data Analytics",
    description1: "Actionable insights for growth.",

    image2: "/assets/home/zip-feature-admin-2.webp",
    title2: "Dynamic Pricing",
    description2: "Adjust based on time, zone, or demand.",

    image3: "/assets/home/zip-feature-admin-3.webp",
    title3: "Fleet Management",
    description3: "Monitor vehicle health and driver activity.",

    image4: "/assets/home/zip-feature-admin-4.webp",
    title4: "Payment Management",
    description4: "Track transactions and manage payouts.",

    image5: "/assets/home/zip-feature-admin-5.webp",
    title5: "Discount & Promotions",
    description5: "Create referral bonuses and discounts.",
  },

  fleet: {
    image1: "/assets/home/zip-feature-2.webp",
    title1: "Customer Management",
    description1: "View ride history and feedback.",

    image2: "/assets/home/zip-feature-fleet-2.webp",
    title2: "Cars Management",
    description2: "Track EV availability and performance.",

    image3: "/assets/home/zip-feature-fleet-3.webp",
    title3: "Documentation Management",
    description3: "Manage legal and regulatory papers.",

    image4: "/assets/home/zip-feature-fleet-4.webp",
    title4: "Car Maintenance",
    description4: "Plan and track EV servicing.",

    image5: "/assets/home/zip-feature-fleet-5.webp",
    title5: "Dynamic Pricing",
    description5: "Adjust fares automatically during peak demand.",
  },
}

const cabifyPlaceData = {
  titlePart1: "All-In-One Business ",
  titlePart2: "Management Tools",
  btn: "more features",
  tab1: {
    title: "Central Dashboard",
    description: "Track operations and key metrics.",
    image: "/assets/home/lyft-place-1.webp",
  },
  tab2: {
    title: "App-Wide Configuration",
    description: "Manage features, roles, and settings.",
    image: "/assets/home/lyft-place-2.webp",
  },
  tab3: {
    title: "Vehicle Category Management",
    description: "Add EVs, premium cars, and more.",
    image: "/assets/home/lyft-place-3.webp",
  },
  tab4: {
    title: "Full site configuration options",
    description: "Fine-tune backend functionalities, user roles, payment gateways, and app behavior.",
    image: "/assets/home/lyft-place-4.webp",
  },
  tab5: {
    title: "Cancellation Policy Customization",
    description: "Set protocols and fees.",
    image: "/assets/home/lyft-place-5.webp",
  },
  tab6: {
    title: "Custom Fare Rules",
    description: "Control base fares, surges, and zones.",
    image: "/assets/home/lyft-place-6.webp",
  },
  tab7: {
    title: "Payout Control Panel",
    description: "Configure payment cycles and accounts.",
    image: "/assets/home/lyft-place-7.webp",
  },
  tab8: {
    title: "Promo Campaign Builder",
    description: "Create seasonal offers and referrals.",
    image: "/assets/home/lyft-place-8.webp",
  },
}

const cabifyMinimumData = {
  tagline: "Why Quality Outshines Cost",
  titlePart1: "Build Beyond",
  titlePart2: "a Basic MVP",
  description: "Launch your taxi app with Mobility Infotech’s Taxi Blue Smart India Clone, designed for long-term success, scalability, and performance.",
  box1: {
    image: "/assets/home/lyft-minimum-1.webp",
    title: "Full Ownership",
  },
  box2: {
    image: "/assets/home/lyft-minimum-2.webp",
    title: "All Premium Features Included",
  },
  box3: {
    image: "/assets/home/lyft-minimum-3.webp",
    title: "Unlimited Free Updates",
  },
  box4: {
    image: "/assets/home/lyft-minimum-4.webp",
    title: "Elegant UI/UX Design",
  },
  box5: {
    image: "/assets/home/lyft-minimum-5.webp",
    title: "Dedicated Support",
  },
  box6: {
    image: "/assets/home/lyft-minimum-6.webp",
    title: "High Performance and Reliability",
  },
  btn: "SEE OUR PRICING PLAN",
}

const cabifySupportData = {
  titlePart1: "Free support, no",
  titlePart2: "additional charge",
  box1: {
    image: "/assets/home/lyft-support-1.webp",
    title: "White-labeling",
    description: "Your logo, colors, and brand name.",
  },
  box2: {
    image: "/assets/home/lyft-support-2.webp",
    title: "Server installation",
    description: "Hosted on your chosen server.",
  },
  box3: {
    image: "/assets/home/lyft-support-3.webp",
    title: "App Store Submission",
    description: "Complete Android & iOS listing.",
  },
  box4: {
    image: "/assets/home/lyft-support-4.webp",
    title: "App rejection support",
    description: "Support for app store approvals.",
  },
}

const faqData = [
  {
    id: "0",
    question: "01. What exactly is the Taxi Blue Smart India Clone App by Mobility Infotech?",
    answer: " It’s a ready-to-deploy, fully customizable taxi booking solution built for the Indian market. It includes passenger, driver, admin, and fleet management modules, ensuring smooth operations across single or multiple cities.",
  },
  {
    id: "1",
    question: "02. How does this app differ from generic taxi booking scripts?",
    answer: " Unlike basic clones, this app comes with enterprise-grade features like surge pricing, EV support, multi-city scaling, advanced analytics, and robust admin tools. It’s designed for business expansion, not just testing.",
  },
  {
    id: "2",
    question: "03. Can I brand this app as my own taxi company?",
    answer: "Yes. The app is 100% white-labeled, meaning your company name, colors, and logo will be integrated throughout the platform.",
  },
  {
    id: "3",
    question: "04. Do I get complete source code ownership?",
    answer: "Absolutely. You receive 100% unencrypted source code for unrestricted scalability and integration flexibility.",
  },
  {
    id: "4",
    question: "05. How soon can I launch my taxi business?",
    answer: "Your app can be live in 7–10 business days, depending on branding and payment integrations.",
  },
  {
    id: "5",
    question: "06. Does it support EV taxis?",
    answer: "Yes. You can add EV categories to align with India’s electric mobility ecosystem.",
  },
];

export default function BlueSmart() {
  return (
    <>
      <CabifyBanner data={bannerData} />
      <CabifyChoose data={chooseData} />

      <Suspense fallback={null}>
        <CabifyFeature data={featureData} />
        <CabifyFeatureTwo data={featureTwoData} />
        <CabifyPlace data={cabifyPlaceData} />
        <CabifyMinimum data={cabifyMinimumData} />
        <CabifySupport data={cabifySupportData} />
        <ShuttleAppreciation />
        <div className="zip-faq-fixer">
          <TaxiFaq faqData={faqData} />
        </div>
      </Suspense>
    </>
  )
}
